export const CREATE_INDIVIDUAL_USER = 'create individual user';
export const READ_INDIVIDUAL_USER = 'read individual user';
export const UPDATE_INDIVIDUAL_USER = 'update individual user';
export const DELETE_INDIVIDUAL_USER = 'delete individual user';

export const CREATE_HOSPITAL_USER = 'create hospital user';
export const READ_HOSPITAL_USER = 'read hospital user';
export const UPDATE_HOSPITAL_USER = 'update hospital user';
export const DELETE_HOSPITAL_USER = 'delete hospital user';

export const CREATE_NURSE_USER = 'create nurse user';
export const READ_NURSE_USER = 'read nurse user';
export const UPDATE_NURSE_USER = 'update nurse user';
export const DELETE_NURSE_USER = 'delete nurse user';

export const APPROVE_HOSPITAL_USER = 'approve hospital user';
export const REJECT_HOSPITAL_USER = 'reject hospital user';
export const APPROVE_NURSE_USER = 'approve nurse user';
export const REJECT_NURSE_USER = 'reject nurse user';

export const BLOCK_USER = 'block user';
export const UNBLOCK_USER = 'unblock user';
export const BLOCK_NURSE = 'block nurse';
export const UNBLOCK_NURSE = 'unblock nurse';

export const CREATE_DEVICE = 'create device';
export const READ_DEVICE = 'read device';
export const UPDATE_DEVICE = 'update device';
export const DELETE_DEVICE = 'delete device';

export const CREATE_ADMIN_NOTIFICATION = 'create admin notification';
export const READ_ADMIN_NOTIFICATION = 'read admin notification';
export const UPDATE_ADMIN_NOTIFICATION = 'update admin notification';
export const DELETE_ADMIN_NOTIFICATION = 'delete admin notification';

export const CREATE_HOSPITAL_NOTIFICATION = 'create hospital notification';
export const READ_HOSPITAL_NOTIFICATION = 'read hospital notification';
export const UPDATE_HOSPITAL_NOTIFICATION = 'update hospital notification';
export const DELETE_HOSPITAL_NOTIFICATION = 'delete hospital notification';

export const VIEW_ADMIN_DASHBOARD = 'view admin dashboard';
export const VIEW_HOSPITAL_DASHBOARD = 'view hospital dashboard';

export const VIEW_ADMIN_SIDEBAR = 'view admin sidebar';
export const VIEW_HOSPITAL_SIDEBAR = 'view hospital sidebar';
export const VIEW_NURSE_SIDEBAR = 'view nurse sidebar';
export const VIEW_INDIVIDUAL_SIDEBAR = 'view individual sidebar';

export const ASSIGN_NURSE = 'assign nurse';
export const CREATE_HOSPITAL_BLOCK = 'create hospital block';
export const READ_HOSPITAL_BLOCK = 'read hospital block';
export const UPDATE_HOSPITAL_BLOCK = 'update hospital block';
export const DELETE_HOSPITAL_BLOCK = 'delete hospital block';

export const VIEW_HOSPITAL_DETAILS = 'view hospital details';
export const VIEW_NURSE_DETAILS = 'view nurse details';
export const VIEW_INDIVIDUAL_DETAILS = 'view individual details';
export const VIEW_DEVICE_DETAILS = 'view device details';

export const VIEW_ALERTS = 'view alerts';
export const DELETE_ALERTS = 'delete alerts';

export const VIEW_ANALYTICS = 'view analytics';
export const VIEW_NOTIFICATION = 'view notification';

export const AUDIT_LOG = 'audit log';
export const ADMIN_ACTIVITY_LOG = 'view activity log';
export const HOSPITAL_MANAGEMENT = 'hospital management';
